import React from "react";
import CalculatorSection from "./CalculatorSection";

// import LightMode from '../img/light-mode.png';
// import DarkMode from '../img/dark-mode.png';

const ShowcaseSection = () => {
	return (
		<div>
			<CalculatorSection />
		</div>
	);
};

export default ShowcaseSection;
